<div class="row">
  <div class="col-12 col-md-4">
    <h4 *ngIf="contractor" class="text-doctor border-bottom pb-2 mb-3"><i
      class="la la-hospital-o"></i> {{contractor.title.raw}}</h4>
    <div class="side-navigation">
      <div *ngIf="contractor">
        <ul class="anchor-type-h2">
          <li routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            <a [routerLink]="['/ustanova', contractor.id]">Ustanova</a>
          </li>
        </ul>
        <ul class="anchor-type-h2" *ngIf="units.length>0">
          <li routerLinkActive="active" onclick="openList(this)">
            <a>Ambulante/Enote</a>
            <i class="listToggle la la-angle-down"></i>
          </li>
          <li class="anchor-type-h3" routerLinkActive="active" *ngFor="let unit of units">
            <a [routerLink]="['/ustanova', contractor.id, 'enota', unit.id]">{{unit.title.raw}}</a>
          </li>
        </ul>
        <ul class="anchor-type-h2" *ngIf="timetables.length > 0">
          <li routerLinkActive="active" onclick="openList(this)">
            <a>Urniki</a>
            <i class="listToggle la la-angle-down"></i>
          </li>
          <li class="anchor-type-h3" routerLinkActive="active" *ngFor="let timetable of timetables">
            <a [routerLink]="['/ustanova', contractor.id, 'urnik', timetable.id]">{{timetable.title.raw}}</a>
          </li>
        </ul>
        <ul class="anchor-type-h2 premium-anchor">
          <ng-container *ngIf="!contractor.acf.contractor_premium">
            <li routerLinkActive="active" [routerLink]="['/ustanova', contractor.id, 'premium-flyer']"
                class="text-mango">
              <a>Premium vsebine</a>
              <i class="la la-lock"></i>
            </li>
          </ng-container>
          <ng-container *ngIf="contractor.acf.contractor_premium">
            <li routerLinkActive="active" onclick="openList(this)" class="text-mango">
              <a>Premium vsebine</a>
              <i class="listToggle la la-angle-down"></i>
            </li>
            <li class="anchor-type-h3" routerLinkActive="active" *ngFor="let premium of premiums">
              <a [routerLink]="['/ustanova', contractor.id, 'premium', premium.id]">{{premium.title.raw}}</a>
            </li>
          </ng-container>
        </ul>
        <ul class="anchor-type-h2 primary-anchor">
          <li class="text-primary">
            <a href="{{contractor.link}}" target="_blank" class="text-primary">Ogled strani</a>
            <i class="la la-external-link"></i>
          </li>
        </ul>
        <ul class="anchor-type-h2 primary-anchor">
          <li class="text-primary">
            <a [href]="faqUrl" target="_blank" class="text-primary">Pomoč</a>
            <i class="la la-external-link"></i>
          </li>
        </ul>
        <div *ngIf="loadingData" class="alert alert-light">
          <strong>
            <i class="la la-spinner la-spin"></i> Nalagam podatke
          </strong>
        </div>
        <hr>
        <div *ngIf="user" class="mt-3 mb-2 d-flex justify-content-between">
          <strong class="text-primary" style="font-size: 1rem">
            <i class="la la-user"></i> {{user.user_display_name}}
          </strong>
        </div>
        <div>
          <button class="button button-3d button-leaf button-small m-0 mr-2 mb-2 px-2"
                  [routerLink]="['/ustanova', contractor.id, 'change-password']">
            <i class="la la-key"></i> Sprememba gesla
          </button>
          <button class="button button-3d button-yellow button-small m-0 px-2" (click)="logout()">
            <i class="la la-sign-out"></i> Odjava
          </button>
        </div>
      </div>
    </div>

  </div>
  <div class="col-12 col-md-8">
    <router-outlet></router-outlet>
  </div>
</div>



